export default "__VITE_ASSET__95ef44de__"